import {Action, createReducer, on} from '@ngrx/store';
import {
  visibilities,
  setNotification,
  resetNotifications, deleteNotification, setBackendIdentifier
} from '../actions/global.actions';
import {GlobalState, initialGlobalState} from '../state/global.state';
import {v4 as uuidv4} from 'uuid';

export const initialState: GlobalState = initialGlobalState();

const GlobalReducer = createReducer(
  initialState,
  on(setBackendIdentifier, (state: GlobalState, {backendIdentifier}): GlobalState => {
      return {
        ...state,
        backendIdentifier
      }
    }
  ),
  on(setNotification, (state: GlobalState, {notification, notificationType}): GlobalState => {
      let notifications: null | {
        id: string,
        notification: string,
        type: 'info' | 'error'
      }[];
      if (state.notifications) {
        notifications = [...state.notifications];
        notifications.unshift({id: uuidv4(), notification: notification, type: notificationType});
      } else {
        notifications = [{id: uuidv4(), notification: notification, type: notificationType}];
      }
      return {
        ...state,
        notifications: notifications
      }
    }
  ),
  on(deleteNotification, (state: GlobalState, {id}): GlobalState => {
      let notifications = state.notifications?.filter(n => n.id != id) ?? null
      if (notifications && notifications.length == 0) {
        notifications = null;
      }
      return {
        ...state,
        notifications
      }
    }
  ),
  on(resetNotifications, (state: GlobalState, {types}): GlobalState => {
      let notifications = state.notifications?.filter(x => !types?.includes(x.type)) ?? null;
      if (notifications && notifications.length == 0) {
        notifications = null;
      }
      return {
        ...state,
        notifications
      }
    }
  ),

  on(visibilities, (state: GlobalState, {property, value}): GlobalState => {
    return {
      ...state,
      visibilities: {
        ...state.visibilities,
        [property]: value
      }
    }
  })


);

export function reducer(state: GlobalState | undefined, action: Action) {
  return GlobalReducer(state, action);
}
